export default __webpack_public_path__ + "static/media/socialimpact2.d64ac0eb.jpeg";